import { getCurrentDeviceBrandAndModel } from "./deviceDetection";

export default function getDeviceData() {
  return getCurrentDeviceBrandAndModel();
}
